import { render, staticRenderFns } from "./shopPurchases.vue?vue&type=template&id=1ce8dc48"
import script from "./shopPurchases.vue?vue&type=script&lang=js"
export * from "./shopPurchases.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports